<div class="row">
  <div class="col">
    <div class="row mt-3">
      <ng-container *ngFor="let additionalCost of additionalCostsCustomArray">
        <div class="col-12 col-md-3 p-2">
          <!-- groupNumber-->
          <div class="card m-0" *ngIf="additionalCost.typeField === 'groupNumber'">
            <h5 class="card-title text-center p-2 mb-0" [style.background-color]="additionalCost.value > 0 ? '#17a2b8' : '#f5f5f5'" [style.color]="additionalCost.value > 0 ? '#FFFFFF' : '#000000'">
              <strong>
                {{'event.additionalCosts.' + additionalCost.name + '.title' | translate}}
                <ng-container *ngIf="additionalCost.value > 0">
                  ({{additionalCost.value}})
                </ng-container>

              </strong></h5>
            <div class="card-price p-2">
            <h5 class="text-center p-2 mb-0"><span style="white-space:nowrap; font-weight: bold;">{{additionalCost.cost}} {{additionalCost.typeShow === 'showValue' ? '€': '%'}}</span></h5>
            </div>
            <ul class="list-group list-group-flush">
            <li class="list-group-item border-bottom-0 p-2">
              <app-form-group-number-input
                [offset]="additionalCost.id === 12 ? 10 : 1"
                [(model)]="additionalCost.quantity"
                (modelChange)="onAdditionalCostNumberInputChange(additionalCost.name)"
              >
              </app-form-group-number-input>
            </li>
            </ul>
          </div>
          <!-- radio-->
          <div class="card m-0" *ngIf="additionalCost.typeField === 'radio'">
            <h5 class="card-title text-center p-2 mb-0" [style.background-color]="additionalCost.quantity === 1 ? '#17a2b8' : '#f5f5f5'" [style.color]="additionalCost.quantity === 1 ? '#FFFFFF' : '#000000'"><strong>{{'event.additionalCosts.' + additionalCost.name + '.title' | translate}}</strong></h5>
            <div class="card-price p-2">
            <h5 class="text-center p-2 mb-0"><span style="white-space:nowrap; font-weight: bold;">{{additionalCost.cost}} {{additionalCost.typeShow === 'showValue' ? '€': '%'}}</span></h5>
            </div>
            <ul class="list-group list-group-flush">
            <li class="list-group-item border-bottom-0 p-2">
              <div
              class="row"
              >
              <div class="col text-center">
                <div class="form-check form-check-inline">
                <input class="form-check-input"
                  type="radio"
                  [name]="additionalCost.name"
                  [(ngModel)]="additionalCost.quantity"
                  (change)="onAdditionalCostNumberInputChange(additionalCost.name)"
                  id="mainDeviceCheckTrue"
                  [value]="1"
                />
                <label>Yes</label>
                </div>
              </div>
              <div class="col text-center">
                <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="radio"
                  [name]="additionalCost.name"
                  [(ngModel)]="additionalCost.quantity"
                  (change)="onAdditionalCostNumberInputChange(additionalCost.name)"
                  id="mainDeviceCheckFalse"
                  [value]="-1"
                />
                <label>No</label>
                </div>
              </div>
              </div>
            </li>
            </ul>
          </div>
        </div>
        <div class="col-12 hr-space d-none d-md-block" *ngIf="additionalCost.endRow"><hr/></div>
      </ng-container>
    </div>
    <div class="row mt-3">
        <div class="col text-right">
          <button type="button" class="btn btn-primary btn-sm" (click)="saveData()">Request</button>
        </div>
    </div>
  </div>
</div>
